/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AttributeConfigVO } from '../model';
// @ts-ignore
import { AttributeExternalConfigVO } from '../model';
// @ts-ignore
import { AttributeExternalValueVO } from '../model';
// @ts-ignore
import { DiscriminatorLayerVO } from '../model';
// @ts-ignore
import { EnumTypZroje } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * AttributesControllerApi - axios parameter creator
 * @export
 */
export const AttributesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Metoda pro změnu příznaku `diskriminátor` na atributu
         * @param {number} idAtribut 
         * @param {boolean} discriminator 
         * @param {string} [defaultAtributValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDiscriminator: async (idAtribut: number, discriminator: boolean, defaultAtributValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idAtribut' is not null or undefined
            assertParamExists('changeDiscriminator', 'idAtribut', idAtribut)
            // verify required parameter 'discriminator' is not null or undefined
            assertParamExists('changeDiscriminator', 'discriminator', discriminator)
            const localVarPath = `/api/userLayers/attributes/{idAtribut}/changeDiscriminator`
                .replace(`{${"idAtribut"}}`, encodeURIComponent(String(idAtribut)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discriminator !== undefined) {
                localVarQueryParameter['discriminator'] = discriminator;
            }

            if (defaultAtributValue !== undefined) {
                localVarQueryParameter['defaultAtributValue'] = defaultAtributValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro vytvoření atributu
         * @param {number} layerId 
         * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAtribut: async (layerId: number, attributeConfigVO: AttributeConfigVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('createAtribut', 'layerId', layerId)
            // verify required parameter 'attributeConfigVO' is not null or undefined
            assertParamExists('createAtribut', 'attributeConfigVO', attributeConfigVO)
            const localVarPath = `/api/attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attributeConfigVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zjistí, zda existují data odkazující na daný číselník
         * @param {number} ciselnikId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsDataForCiselnik: async (ciselnikId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ciselnikId' is not null or undefined
            assertParamExists('existsDataForCiselnik', 'ciselnikId', ciselnikId)
            const localVarPath = `/api/attributes/existsDataForCiselnik`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ciselnikId !== undefined) {
                localVarQueryParameter['ciselnikId'] = ciselnikId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zjistí, zda existují data odkazující na číselníky daného atributu
         * @param {number} atributId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsDataForCiselnikyAtributu: async (atributId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'atributId' is not null or undefined
            assertParamExists('existsDataForCiselnikyAtributu', 'atributId', atributId)
            const localVarPath = `/api/attributes/existsDataForCiselnikyAtributu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (atributId !== undefined) {
                localVarQueryParameter['atributId'] = atributId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro získání všech atributů vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAtribut: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getAllAtribut', 'layerId', layerId)
            const localVarPath = `/api/attributes/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí všechny podřízené vrstvy pro tuto vrstvu
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscriminatorLayers: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getDiscriminatorLayers', 'layerId', layerId)
            const localVarPath = `/api/userLayers/attributes/{layerId}/discriminatorLayers`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro získání všech atributů z externího zdroje
         * @param {string} typObjektu 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAtribut: async (typObjektu: string, typZdroje?: EnumTypZroje, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'typObjektu' is not null or undefined
            assertParamExists('getExternalAtribut', 'typObjektu', typObjektu)
            const localVarPath = `/api/attributes/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typZdroje !== undefined) {
                localVarQueryParameter['typZdroje'] = typZdroje;
            }

            if (typObjektu !== undefined) {
                localVarQueryParameter['typObjektu'] = typObjektu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro získání hodnot atributů z externího zdroje
         * @param {string} typObjektu 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {string} [kodAtributu] 
         * @param {string} [fulltext] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDefaultValue: async (typObjektu: string, typZdroje?: EnumTypZroje, kodAtributu?: string, fulltext?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'typObjektu' is not null or undefined
            assertParamExists('getExternalDefaultValue', 'typObjektu', typObjektu)
            const localVarPath = `/api/attributes/external/defult`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typZdroje !== undefined) {
                localVarQueryParameter['typZdroje'] = typZdroje;
            }

            if (typObjektu !== undefined) {
                localVarQueryParameter['typObjektu'] = typObjektu;
            }

            if (kodAtributu !== undefined) {
                localVarQueryParameter['kodAtributu'] = kodAtributu;
            }

            if (fulltext !== undefined) {
                localVarQueryParameter['fulltext'] = fulltext;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro přesun atributu ve vrstvě
         * @param {number} layerId 
         * @param {number} atributId 
         * @param {number} newIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAtribut: async (layerId: number, atributId: number, newIndex: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('moveAtribut', 'layerId', layerId)
            // verify required parameter 'atributId' is not null or undefined
            assertParamExists('moveAtribut', 'atributId', atributId)
            // verify required parameter 'newIndex' is not null or undefined
            assertParamExists('moveAtribut', 'newIndex', newIndex)
            const localVarPath = `/api/attributes/move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }

            if (atributId !== undefined) {
                localVarQueryParameter['atributId'] = atributId;
            }

            if (newIndex !== undefined) {
                localVarQueryParameter['newIndex'] = newIndex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro odebrání atributu z vrstvy
         * @param {number} layerId 
         * @param {number} idAtribut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAtribut: async (layerId: number, idAtribut: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('removeAtribut', 'layerId', layerId)
            // verify required parameter 'idAtribut' is not null or undefined
            assertParamExists('removeAtribut', 'idAtribut', idAtribut)
            const localVarPath = `/api/attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }

            if (idAtribut !== undefined) {
                localVarQueryParameter['idAtribut'] = idAtribut;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro update atributu
         * @param {number} idAtribut 
         * @param {number} layerId 
         * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAtribut: async (idAtribut: number, layerId: number, attributeConfigVO: AttributeConfigVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idAtribut' is not null or undefined
            assertParamExists('updateAtribut', 'idAtribut', idAtribut)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateAtribut', 'layerId', layerId)
            // verify required parameter 'attributeConfigVO' is not null or undefined
            assertParamExists('updateAtribut', 'attributeConfigVO', attributeConfigVO)
            const localVarPath = `/api/attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idAtribut !== undefined) {
                localVarQueryParameter['idAtribut'] = idAtribut;
            }

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attributeConfigVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttributesControllerApi - functional programming interface
 * @export
 */
export const AttributesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttributesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Metoda pro změnu příznaku `diskriminátor` na atributu
         * @param {number} idAtribut 
         * @param {boolean} discriminator 
         * @param {string} [defaultAtributValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeDiscriminator(idAtribut: number, discriminator: boolean, defaultAtributValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.changeDiscriminator(idAtribut, discriminator, defaultAtributValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro vytvoření atributu
         * @param {number} layerId 
         * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAtribut(layerId: number, attributeConfigVO: AttributeConfigVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createAtribut(layerId, attributeConfigVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Zjistí, zda existují data odkazující na daný číselník
         * @param {number} ciselnikId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsDataForCiselnik(ciselnikId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.existsDataForCiselnik(ciselnikId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Zjistí, zda existují data odkazující na číselníky daného atributu
         * @param {number} atributId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsDataForCiselnikyAtributu(atributId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.existsDataForCiselnikyAtributu(atributId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro získání všech atributů vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAtribut(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AttributeConfigVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAtribut(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí všechny podřízené vrstvy pro tuto vrstvu
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscriminatorLayers(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscriminatorLayerVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscriminatorLayers(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro získání všech atributů z externího zdroje
         * @param {string} typObjektu 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalAtribut(typObjektu: string, typZdroje?: EnumTypZroje, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AttributeExternalConfigVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalAtribut(typObjektu, typZdroje, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro získání hodnot atributů z externího zdroje
         * @param {string} typObjektu 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {string} [kodAtributu] 
         * @param {string} [fulltext] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalDefaultValue(typObjektu: string, typZdroje?: EnumTypZroje, kodAtributu?: string, fulltext?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AttributeExternalValueVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalDefaultValue(typObjektu, typZdroje, kodAtributu, fulltext, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro přesun atributu ve vrstvě
         * @param {number} layerId 
         * @param {number} atributId 
         * @param {number} newIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveAtribut(layerId: number, atributId: number, newIndex: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.moveAtribut(layerId, atributId, newIndex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro odebrání atributu z vrstvy
         * @param {number} layerId 
         * @param {number} idAtribut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAtribut(layerId: number, idAtribut: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAtribut(layerId, idAtribut, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro update atributu
         * @param {number} idAtribut 
         * @param {number} layerId 
         * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAtribut(idAtribut: number, layerId: number, attributeConfigVO: AttributeConfigVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAtribut(idAtribut, layerId, attributeConfigVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AttributesControllerApi - factory interface
 * @export
 */
export const AttributesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttributesControllerApiFp(configuration)
    return {
        /**
         * Metoda pro změnu příznaku `diskriminátor` na atributu
         * @param {number} idAtribut 
         * @param {boolean} discriminator 
         * @param {string} [defaultAtributValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDiscriminator(idAtribut: number, discriminator: boolean, defaultAtributValue?: string, options?: any): AxiosPromise<void> {
            return localVarFp.changeDiscriminator(idAtribut, discriminator, defaultAtributValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro vytvoření atributu
         * @param {number} layerId 
         * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAtribut(layerId: number, attributeConfigVO: AttributeConfigVO, options?: any): AxiosPromise<void> {
            return localVarFp.createAtribut(layerId, attributeConfigVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Zjistí, zda existují data odkazující na daný číselník
         * @param {number} ciselnikId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsDataForCiselnik(ciselnikId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.existsDataForCiselnik(ciselnikId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zjistí, zda existují data odkazující na číselníky daného atributu
         * @param {number} atributId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsDataForCiselnikyAtributu(atributId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.existsDataForCiselnikyAtributu(atributId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro získání všech atributů vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAtribut(layerId: number, options?: any): AxiosPromise<Array<AttributeConfigVO>> {
            return localVarFp.getAllAtribut(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí všechny podřízené vrstvy pro tuto vrstvu
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscriminatorLayers(layerId: number, options?: any): AxiosPromise<Array<DiscriminatorLayerVO>> {
            return localVarFp.getDiscriminatorLayers(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro získání všech atributů z externího zdroje
         * @param {string} typObjektu 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAtribut(typObjektu: string, typZdroje?: EnumTypZroje, options?: any): AxiosPromise<Array<AttributeExternalConfigVO>> {
            return localVarFp.getExternalAtribut(typObjektu, typZdroje, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro získání hodnot atributů z externího zdroje
         * @param {string} typObjektu 
         * @param {EnumTypZroje} [typZdroje] 
         * @param {string} [kodAtributu] 
         * @param {string} [fulltext] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDefaultValue(typObjektu: string, typZdroje?: EnumTypZroje, kodAtributu?: string, fulltext?: string, options?: any): AxiosPromise<Array<AttributeExternalValueVO>> {
            return localVarFp.getExternalDefaultValue(typObjektu, typZdroje, kodAtributu, fulltext, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro přesun atributu ve vrstvě
         * @param {number} layerId 
         * @param {number} atributId 
         * @param {number} newIndex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAtribut(layerId: number, atributId: number, newIndex: number, options?: any): AxiosPromise<void> {
            return localVarFp.moveAtribut(layerId, atributId, newIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro odebrání atributu z vrstvy
         * @param {number} layerId 
         * @param {number} idAtribut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAtribut(layerId: number, idAtribut: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeAtribut(layerId, idAtribut, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro update atributu
         * @param {number} idAtribut 
         * @param {number} layerId 
         * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAtribut(idAtribut: number, layerId: number, attributeConfigVO: AttributeConfigVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateAtribut(idAtribut, layerId, attributeConfigVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttributesControllerApi - interface
 * @export
 * @interface AttributesControllerApi
 */
export interface AttributesControllerApiInterface {
    /**
     * Metoda pro změnu příznaku `diskriminátor` na atributu
     * @param {number} idAtribut 
     * @param {boolean} discriminator 
     * @param {string} [defaultAtributValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    changeDiscriminator(idAtribut: number, discriminator: boolean, defaultAtributValue?: string, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro vytvoření atributu
     * @param {number} layerId 
     * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    createAtribut(layerId: number, attributeConfigVO: AttributeConfigVO, options?: any): AxiosPromise<void>;

    /**
     * Zjistí, zda existují data odkazující na daný číselník
     * @param {number} ciselnikId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    existsDataForCiselnik(ciselnikId: number, options?: any): AxiosPromise<boolean>;

    /**
     * Zjistí, zda existují data odkazující na číselníky daného atributu
     * @param {number} atributId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    existsDataForCiselnikyAtributu(atributId: number, options?: any): AxiosPromise<boolean>;

    /**
     * Metoda pro získání všech atributů vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    getAllAtribut(layerId: number, options?: any): AxiosPromise<Array<AttributeConfigVO>>;

    /**
     * Vrátí všechny podřízené vrstvy pro tuto vrstvu
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    getDiscriminatorLayers(layerId: number, options?: any): AxiosPromise<Array<DiscriminatorLayerVO>>;

    /**
     * Metoda pro získání všech atributů z externího zdroje
     * @param {string} typObjektu 
     * @param {EnumTypZroje} [typZdroje] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    getExternalAtribut(typObjektu: string, typZdroje?: EnumTypZroje, options?: any): AxiosPromise<Array<AttributeExternalConfigVO>>;

    /**
     * Metoda pro získání hodnot atributů z externího zdroje
     * @param {string} typObjektu 
     * @param {EnumTypZroje} [typZdroje] 
     * @param {string} [kodAtributu] 
     * @param {string} [fulltext] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    getExternalDefaultValue(typObjektu: string, typZdroje?: EnumTypZroje, kodAtributu?: string, fulltext?: string, options?: any): AxiosPromise<Array<AttributeExternalValueVO>>;

    /**
     * Metoda pro přesun atributu ve vrstvě
     * @param {number} layerId 
     * @param {number} atributId 
     * @param {number} newIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    moveAtribut(layerId: number, atributId: number, newIndex: number, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro odebrání atributu z vrstvy
     * @param {number} layerId 
     * @param {number} idAtribut 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    removeAtribut(layerId: number, idAtribut: number, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro update atributu
     * @param {number} idAtribut 
     * @param {number} layerId 
     * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApiInterface
     */
    updateAtribut(idAtribut: number, layerId: number, attributeConfigVO: AttributeConfigVO, options?: any): AxiosPromise<void>;

}

/**
 * AttributesControllerApi - object-oriented interface
 * @export
 * @class AttributesControllerApi
 * @extends {BaseAPI}
 */
export class AttributesControllerApi extends BaseAPI implements AttributesControllerApiInterface {
    /**
     * Metoda pro změnu příznaku `diskriminátor` na atributu
     * @param {number} idAtribut 
     * @param {boolean} discriminator 
     * @param {string} [defaultAtributValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public changeDiscriminator(idAtribut: number, discriminator: boolean, defaultAtributValue?: string, options?: any) {
        return AttributesControllerApiFp(this.configuration).changeDiscriminator(idAtribut, discriminator, defaultAtributValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro vytvoření atributu
     * @param {number} layerId 
     * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public createAtribut(layerId: number, attributeConfigVO: AttributeConfigVO, options?: any) {
        return AttributesControllerApiFp(this.configuration).createAtribut(layerId, attributeConfigVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zjistí, zda existují data odkazující na daný číselník
     * @param {number} ciselnikId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public existsDataForCiselnik(ciselnikId: number, options?: any) {
        return AttributesControllerApiFp(this.configuration).existsDataForCiselnik(ciselnikId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zjistí, zda existují data odkazující na číselníky daného atributu
     * @param {number} atributId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public existsDataForCiselnikyAtributu(atributId: number, options?: any) {
        return AttributesControllerApiFp(this.configuration).existsDataForCiselnikyAtributu(atributId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro získání všech atributů vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public getAllAtribut(layerId: number, options?: any) {
        return AttributesControllerApiFp(this.configuration).getAllAtribut(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí všechny podřízené vrstvy pro tuto vrstvu
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public getDiscriminatorLayers(layerId: number, options?: any) {
        return AttributesControllerApiFp(this.configuration).getDiscriminatorLayers(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro získání všech atributů z externího zdroje
     * @param {string} typObjektu 
     * @param {EnumTypZroje} [typZdroje] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public getExternalAtribut(typObjektu: string, typZdroje?: EnumTypZroje, options?: any) {
        return AttributesControllerApiFp(this.configuration).getExternalAtribut(typObjektu, typZdroje, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro získání hodnot atributů z externího zdroje
     * @param {string} typObjektu 
     * @param {EnumTypZroje} [typZdroje] 
     * @param {string} [kodAtributu] 
     * @param {string} [fulltext] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public getExternalDefaultValue(typObjektu: string, typZdroje?: EnumTypZroje, kodAtributu?: string, fulltext?: string, options?: any) {
        return AttributesControllerApiFp(this.configuration).getExternalDefaultValue(typObjektu, typZdroje, kodAtributu, fulltext, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro přesun atributu ve vrstvě
     * @param {number} layerId 
     * @param {number} atributId 
     * @param {number} newIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public moveAtribut(layerId: number, atributId: number, newIndex: number, options?: any) {
        return AttributesControllerApiFp(this.configuration).moveAtribut(layerId, atributId, newIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro odebrání atributu z vrstvy
     * @param {number} layerId 
     * @param {number} idAtribut 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public removeAtribut(layerId: number, idAtribut: number, options?: any) {
        return AttributesControllerApiFp(this.configuration).removeAtribut(layerId, idAtribut, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro update atributu
     * @param {number} idAtribut 
     * @param {number} layerId 
     * @param {AttributeConfigVO} attributeConfigVO Objekt atributu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesControllerApi
     */
    public updateAtribut(idAtribut: number, layerId: number, attributeConfigVO: AttributeConfigVO, options?: any) {
        return AttributesControllerApiFp(this.configuration).updateAtribut(idAtribut, layerId, attributeConfigVO, options).then((request) => request(this.axios, this.basePath));
    }
}
